import { CalcHeaders } from './calcHeader';

// tslint:disable-next-line:class-name
export class pgiAuthors {
  id: number;
  authorName: string;
  userId: number;
  notes: string;
  archiwalny: boolean;
  notes2: string;
  accountBalance: number;
  authorId: number;
  public pgiCalcHeader: CalcHeaders[];
}
